theme.SlideShow = (function () {
  function Slider(e) {
    this.container = e;
    const initialWrapper = e.querySelector(".hero__slider--activation");
    if (!initialWrapper) return;
    // Use real rendered slides, not configured/disabled blocks.
    const originalSlides = initialWrapper.querySelectorAll(".swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate)");
    const stableHero = e.dataset.msStableHero === "true";
    if (stableHero && originalSlides.length === 1) {
      e.dataset.msStaticSlide = "true";
      originalSlides[0].classList.add("swiper-slide-active");
      return;
    }
    if (typeof Swiper === "undefined" || !originalSlides.length) return;
    // Avoid a second Swiper on a section that the theme editor has already initialized.
    if (initialWrapper.swiper && !initialWrapper.swiper.destroyed) {
      this.swiper = initialWrapper.swiper;
      return;
    }
    let sliderWrapper = e.querySelector(".hero__slider--activation"),
      slideLoop = e.dataset.slideLoop,
      slideAutoplay = e.dataset.slideAutoplay,
      autoplayDuration = e.dataset.autoplayDuration,
      slideLoopValue = true,
      autoplay = false,
      slideNavPrev = e.querySelector(".swiper-button-prev"),
      slideNavNext = e.querySelector(".swiper-button-next"),
      sliderPagination = e.querySelector(".swiper-pagination"),
      slideShowSpace = parseInt(e.dataset.slideshow)
        ? parseInt(e.dataset.slideshow)
        : 0,
      sliderPerView = parseInt(e.dataset.slidesperview)
        ? parseInt(e.dataset.slidesperview)
        : 1,
      smallDesktop = parseInt(e.dataset.samlldesktopview)
        ? parseInt(e.dataset.samlldesktopview)
        : 1,
      tabletShow = parseInt(e.dataset.showTablet)
        ? parseInt(e.dataset.showTablet)
        : 1,
      mobileShow = parseInt(e.dataset.showMobile)
        ? parseInt(e.dataset.showMobile)
        : 1;

    //console.log(sliderPerView);

    if (slideLoop == "false") {
      slideLoopValue = false;
    }
    const reduceMotion = stableHero && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (slideAutoplay == "true" && !reduceMotion) {
      let sliderDuration = parseInt(autoplayDuration);
      autoplay = { delay: autoplayDuration, disableOnInteraction: false };
    }

    var swiper = new Swiper(sliderWrapper, {
      slidesPerView: mobileShow,
      autoplay: autoplay,
      loop: slideLoopValue,
      clickable: true,
      speed: reduceMotion ? 0 : 1000,
      spaceBetween: slideShowSpace,
      pagination: {
        el: sliderPagination,
        clickable: true,
      },
      navigation: {
        nextEl: slideNavNext,
        prevEl: slideNavPrev,
      },
      breakpoints: {
        0: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: tabletShow,
        },
        992: {
          slidesPerView: smallDesktop,
        },
        1200: {
          slidesPerView: sliderPerView,
        },
      },
    });
    this.swiper = swiper;
    // Slide thumbnail height
    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");
      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };
    slideThumbHeight();
    this.resizeHandler = slideThumbHeight;
    window.addEventListener("resize", this.resizeHandler);
  }
  Slider.prototype.onUnload = function () {
    if (this.resizeHandler) window.removeEventListener("resize", this.resizeHandler);
    if (this.swiper && !this.swiper.destroyed) this.swiper.destroy(true, true);
    this.swiper = null;
  };
  return Slider;
})();
